/* eslint-disable complexity */
import * as actions from '../actions/route-group-collection';
import * as models from '../../domain/models';

import * as _ from 'lodash';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  routeGroups: Array<models.RouteGroup>;
}

const initialState: State = {
  isLoading: false,
  isLoaded: false,
  routeGroups: [],
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    }

    case actions.LOAD_SUCCESS: {
      const routeGroups = _.cloneDeep(action.payload.entities);

      return {
        routeGroups,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getRouteGroups = (state: State) => state.routeGroups;
